import { Search } from "lucide-react";
import { useRef } from "react";
import { Kbd } from "./ui/Kbd";
import { useTaskStore } from "../stores/taskStore";

export function SearchBox() {
  const ref = useRef<HTMLInputElement>(null);
  const search = useTaskStore((s) => s.search);
  const setSearch = useTaskStore((s) => s.setSearch);
  return (
    <div className="mx-8 mb-4 flex h-11 items-center gap-3 rounded-md border border-border bg-card px-3 shadow-sm dark:border-border-dark dark:bg-card-dark">
      <Search className="h-4 w-4 text-muted" />
      <input ref={ref} value={search} onChange={(e) => void setSearch(e.target.value)} placeholder="検索" className="h-full flex-1 bg-transparent text-sm outline-none placeholder:text-dim" />
      <Kbd>⌘F</Kbd>
    </div>
  );
}
